import { genComponentEl } from '@/utils/utils';
import Component from './matter-component.vue';

/**
 *更新HT300设备信息
 *
 * @param {Object} data
 */
export function showMatterInfoDialog(data) {
  genComponentEl(Component, data);
}
